export const ENDPOINT_USER_GET = '/api/v1/user/me';
export const ENDPOINT_USER_UPDATE = '/api/v1/user/update-profile';
export const ENDPOINT_USER_DELETE_ACCOUNT = '/api/v1/user/delete-account';
